import Resizer from 'react-image-file-resizer';

export const ResizeImage =(data , width ,height)=>{
    return new Promise((resolve)=>{
        let image = data
        Resizer.imageFileResizer(
            image,
            width,
            height,
            'WEBP',
            80,
            0,
            (uri) => {
                let byteString =  atob(uri.split(',')[1]) ;
                let mimeString = uri.split(',')[0].split(':')[1].split(';')[0];
                // write the bytes of the string to an ArrayBuffer
                let ab = new ArrayBuffer(byteString.length);
                // create a view into the buffer
                let ia = new Uint8Array(ab);
                // set the bytes of the buffer to the correct values
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i)
                }
                // write the ArrayBuffer to a blob, and you're done
                let blob = new Blob([ab], { type: mimeString });
                resolve(blob)
            },
            'base64'
            );
    })
}